import { FC, useMemo } from 'react'

import ReactSelect from 'react-select'

import { Option } from '@legacy/types/SelectorValues'

import { Container, SelectStyle } from './styles'
import { SearchableSelectProps } from './types'
import { prepareSelectorValues } from './utilities'

const SearchableSelect: FC<React.PropsWithChildren<SearchableSelectProps>> = ({
  onChange,
  onBlur,
  options,
  disabled,
  invalid,
  label,
  value,
  groupBy,
}) => {
  const searchableOptions = useMemo(() => prepareSelectorValues(options, groupBy), [options, groupBy])

  const currentValue = useMemo(() => {
    const option = options.find((opt: Option) => opt.value === value)
    return option
      ? {
          label: option.text,
          value: option.value,
        }
      : null
  }, [options, value])

  return (
    <Container>
      <ReactSelect
        options={searchableOptions}
        isDisabled={disabled}
        placeholder={label}
        onChange={onChange}
        onBlur={onBlur}
        styles={SelectStyle(invalid)}
        value={currentValue}
      />
    </Container>
  )
}

export default SearchableSelect
